import Peer from 'peerjs';
import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';
import store from './index';
import { GameState } from '@/schema/GameState';

interface PeerData{
  type: string,
  message: any,
}

function getPeer() {
  const peer = new Peer();
  peer.on('open', (id) => {
    console.log(id);

    const gameStore = getModule(GameStore);
    GameStore.conn = peer.connect('playifgameooxx');
    GameStore.conn.on('open', () => {
      gameStore.initialGame();
    });
    GameStore.conn.on('data', ({ type, message }: PeerData) => {
      switch (type) {
        case 'state': {
          // const state = new GameState();
          // state.decode(message);
          gameStore.setGameState(message);
          break;
        }
        case 'powerup':
          console.log('powerup', message, 2);
          break;
        default:
          throw new Error(`not know type: ${type}`);
      }
    });
  });
  return peer;
}

@Module({ dynamic: true, store, name: 'GameStore' })
class GameStore extends VuexModule {
  static peer = getPeer();

  static conn: Peer.DataConnection;

  get cards() {
    return this.gameStateJson.cards;
  }

  get players() {
    // return Array.from(this.gameState.players.values());
    return Object.values(this.gameStateJson.players);
  }

  gameState = new GameState();

  gameStateJson: any = this.gameState.toJSON();

  @Mutation
  setGameState(message: number[]): void {
    // console.log('qq', gameState.toJSON());
    console.log(this.gameState.decode(message));
    // console.log(this.gameState.toJSON());
    // const newState = new GameState();
    // newState.decode(this.gameState.encodeAll());
    // this.gameState = newState;
    // this.gameState = this.gameState.clone();
    this.gameStateJson = this.gameState.toJSON();
  }

  @Action
  async shuffle(): Promise<void> {
    GameStore.conn.send({
      type: 'action',
      message: 'shuffle',
    });
  }

  @Action
  async initialGame(): Promise<void> {
    GameStore.conn.send({
      type: 'ack',
      message: 'initial_game',
    });
  }
}

export default getModule(GameStore);
